const getRequestUrl = (input: RequestInfo | URL): string => {
  if (typeof input === "string") {
    return input;
  }
  return input instanceof URL ? input.href : input.url;
};

export const redirectToLogin = () => {
  if (!window.location.pathname.startsWith("/s/")) {
    return;
  }

  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.open(`/login?redirect=${encodeURIComponent(currentUrl)}`, "_self");
};

export const initializeUnauthorizedRedirect = () => {
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const response = await originalFetch(input, init);
    if (response.status === 401 && getRequestUrl(input).startsWith(window.gxApiConnection)) {
      redirectToLogin();
    }
    return response;
  };
};
